export type ChargebeeProduct =
  | 'sales-2026'
  | 'operations'
  | 'additional-team-user'
  | 'additional-crew-user'
  | 'sales'
  | 'crm'
  | 'office-user'
  | 'additional-crew-user-legacy'

export function getChargebeeProductPrice(product: ChargebeeProduct): { monthly: number; yearly: number } {
  switch (product) {
    case 'sales-2026':
      return { monthly: 119, yearly: 99 * 12 }
    case 'operations':
      return { monthly: 99, yearly: 79 * 12 }
    case 'additional-team-user':
      return { monthly: 20, yearly: 20 * 12 }
    case 'additional-crew-user':
      return { monthly: 0, yearly: 0 }
    case 'sales':
      return { monthly: 119, yearly: 99 * 12 }
    case 'crm':
      return { monthly: 49, yearly: 42 * 12 }
    case 'office-user':
      return { monthly: 49, yearly: 42 * 12 }
    case 'additional-crew-user-legacy':
      return { monthly: 19, yearly: 19 * 12 }
  }
}
